import React from "react";
import { Routes, Route, Navigate } from "react-router-dom";
import ProtectedRoute from "./components/ProtectedRoute";
import ProtectedAdminRoute from "./components/ProtectedAdminRoute";
import ProtectedSuperRoute from "./components/ProtectedSuperRoute";
import ProtectedAgentRoute from "./components/ProtectedAgentRoute";
import PublicRoute from "./components/PublicRoute";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import 'leaflet/dist/leaflet.css';

import Home from "./pages/Home";
import About from "./pages/About";
import Login from "./pages/Login";
import Register from "./pages/Register";
import Verify from "./pages/VerifyCode";
import ForgotPassword from "./pages/ForgotPassword";
import ResetPassword from "./pages/ResetPassword";
import TrackTransaction from "./pages/TrackTransaction";
import NotFound from "./pages/NotFound";
import Support from "./pages/Support";
import Feedback from "./pages/Feedback";
import PrivacyPolicy from "./pages/PrivacyPolicy";
import TermsOfUse from "./pages/TermsOfUse";

import Dashboard from "./pages/Dashboard";
import AccountSettingsPage from "./pages/AccountSettings";
import ReceiptPage from "./pages/Receipt";
import SuccessPage from "./pages/SuccessPage";
import BankDetailsPage from "./pages/BankDetailsPage";
import WalletPay from "./pages/WalletPay";
import AdminPanel from "./components/sections/AdminPanelSection";
import AdminDashboard from "./pages/AdminDashboard";
import SuperDashboard from "./pages/SuperDashboard";
import AgentDashboard from "./pages/AgentDashboard";
import AdminProfile from "./pages/AdminProfile";
import AdminSettings from "./pages/AdminSettings";
import AdminLog from "./pages/AdminLog";
import AdminReport from "./pages/AdminReport";
import AdminTransaction from "./pages/AdminTransaction";
import AdminUsers from "./pages/AdminUsers";
import WalletWithdrawal from "./pages/WalletWithdrawal";
import RefundHistory from "./pages/RefundHistory";
import { WithdrawalConfirm } from "./pages/WithdrawalConfirm";
import { WithdrawalReceipt } from "./pages/WithdrawalReceipt";
import FundWallet from "./pages/FundWallet";
import { FundWalletConfirm } from "./pages/FundWalletConfirm";
import { FundWalletReceipt } from "./pages/FundWalletReceipt";
import WalletPayReceipt from "./pages/WalletPayReceipt";
import WalletTransactionReceipt from "./pages/WalletTransactionReceipt";
import AdminUserView from "./pages/AdminUserView";
import AdminUserForm from "./pages/AdminUserForm";
import AdminSupportTicket from "./pages/AdminSupportTicket";
import AdminRefunds from "./pages/AdminRefunds";
import SuperAdminRefunds from "./pages/SuperAdminRefunds";
import SuperProfile from "./pages/SuperAdminProfile";
import SuperSettings from "./pages/SuperAdminSettings";
import SuperReport from "./pages/SuperAdminReport";
import SuperLogin from "./pages/SuperAdminLog";
import SuperTicket from "./pages/SuperAdminSupport";
import SuperTransaction from "./pages/SuperAdminTransaction";
import SuperUsers from "./pages/SuperAdminUsers";
import SuperAdminUserView from "./pages/SuperAdminViewUser";
import SuperAdminUserForm from "./pages/SuperAdminUserForm";
import AdminInvoice from "./pages/AdminInvoice";
import SuperInvoice from "./pages/SuperAdminInvoice";
import AdminUserInvoice from "./pages/AdminUserInvoice";
import AdminUserTransaction from "./pages/AdminUserTransaction";
import SuperUserInvoice from "./pages/SuperAdminUserInvoice";
import SuperUserTransaction from "./pages/SuperAdminUserTransaction";

export default function App() {

  return (
    <>
      <Routes>
        {/* Public Routes */}
        <Route
          path="/"
          element={
            <PublicRoute>
              <Home />
            </PublicRoute>
          }
        />
        <Route
          path="/about"
          element={
            <PublicRoute>
              <About />
            </PublicRoute>
          }
        />
        <Route
          path="/login"
          element={
            <PublicRoute>
              <Login />
            </PublicRoute>
          }
        />
        <Route
          path="/register"
          element={
            <PublicRoute>
              <Register />
            </PublicRoute>
          }
        />
        <Route
          path="/verify"
          element={
            <PublicRoute>
              <Verify />
            </PublicRoute>
          }
        />
        <Route
          path="/forgot-password"
          element={
            <PublicRoute>
              <ForgotPassword />
            </PublicRoute>
          }
        />
        <Route
          path="/reset-password"
          element={
            <PublicRoute>
              <ResetPassword />
            </PublicRoute>
          }
        />
        <Route path="/track" element={<TrackTransaction />} />
        <Route path="/support" element={<Support />} />
        <Route path="/feedback" element={<Feedback />} />
        <Route path="/privacy-policy" element={<PrivacyPolicy />} />
        <Route path="/terms-of-use" element={<TermsOfUse />} />
        <Route
          path="/receipt"
          element={
            <PublicRoute>
              <ReceiptPage />
            </PublicRoute>
          }
        />
        <Route
          path="/payment-success"
          element={
            <PublicRoute>
              <SuccessPage />
            </PublicRoute>
          }
        />
        <Route
          path="/bank-details/:method/:reference"
          element={
            <PublicRoute>
              <BankDetailsPage />
            </PublicRoute>
          }
        />

        {/* Protected Routes */}
        <Route
          path="/dashboard"
          element={
            <ProtectedRoute>
              <Dashboard />
            </ProtectedRoute>
          }
        />
        <Route
          path="/wallet-pay"
          element={
            <ProtectedRoute>
              <WalletPay />
            </ProtectedRoute>
          }
        />
        <Route
          path="/withdraw"
          element={
            <ProtectedRoute>
              <WalletWithdrawal />
            </ProtectedRoute>
          }
        />
        <Route
          path="/withdraw/history"
          element={
            <ProtectedRoute>
              <RefundHistory />
            </ProtectedRoute>
          }
        />

        <Route
          path="/wallet/withdraw/confirm"
          element={
            <ProtectedRoute>
              <WithdrawalConfirm />
            </ProtectedRoute>
          }
        />
        
       <Route
          path="/wallet/withdraw/receipt"
          element={
            <ProtectedRoute>
              <WithdrawalReceipt />
            </ProtectedRoute>
          }
        />

        <Route
          path="/fund-wallet"
          element={
            <ProtectedRoute>
              <FundWallet />
            </ProtectedRoute>
          }
        />

        <Route
          path="/wallet/fund/confirm"
          element={
            <ProtectedRoute>
              <FundWalletConfirm />
            </ProtectedRoute>
          }
        />

        <Route
          path="/wallet/fund/receipt"
          element={
            <ProtectedRoute>
              <FundWalletReceipt />
            </ProtectedRoute>
          }
        />

        <Route
          path="/wallet-pay/receipt"
          element={
            <ProtectedRoute>
              <WalletPayReceipt />
            </ProtectedRoute>
          }
        />

        <Route
          path="/wallet/transaction-receipt"
          element={
            <ProtectedRoute>
              <WalletTransactionReceipt />
            </ProtectedRoute>
          }
        />

        <Route
          path="/profile/edit"
          element={
            <ProtectedRoute>
              <AccountSettingsPage />
            </ProtectedRoute>
          }
        />

        <Route
          path="/admindashboard"
          element={
            <ProtectedAdminRoute>
              <AdminDashboard />
            </ProtectedAdminRoute>
          }
        />
        <Route
          path="/admin/profile"
          element={
            <ProtectedAdminRoute>
              <AdminProfile />
            </ProtectedAdminRoute>
          }
        />

        <Route
          path="/admin/settings"
          element={
            <ProtectedAdminRoute>
              <AdminSettings />
            </ProtectedAdminRoute>
          }
        />

        <Route
          path="/admin/activity-log"
          element={
            <ProtectedAdminRoute>
              <AdminLog />
            </ProtectedAdminRoute>
          }
        />

        <Route
          path="/admin/reports"
          element={
            <ProtectedAdminRoute>
              <AdminReport />
            </ProtectedAdminRoute>
          }
        />

        <Route
          path="/admin/support"
          element={
            <ProtectedAdminRoute>
              <AdminSupportTicket />
            </ProtectedAdminRoute>
          }
        />

        <Route
          path="/admin/refunds"
          element={
            <ProtectedAdminRoute>
              <AdminRefunds />
            </ProtectedAdminRoute>
          }
        />

        <Route
          path="/admin/transactions"
          element={
            <ProtectedAdminRoute>
              <AdminTransaction />
            </ProtectedAdminRoute>
          }
        />

        <Route
          path="/admin/invoice"
          element={
            <ProtectedAdminRoute>
              <AdminInvoice />
            </ProtectedAdminRoute>
          }
        />

        <Route path="/admin/invoices/user/:userId" element={
          
          <ProtectedAdminRoute>
            <AdminUserInvoice />
          </ProtectedAdminRoute>
        }

       />

        <Route path="/admin/transaction/user/:userId" element={
          
          <ProtectedAdminRoute>
            <AdminUserTransaction />
          </ProtectedAdminRoute>
        }

       />

        <Route
          path="/admin/users"
          element={
            <ProtectedAdminRoute>
              <AdminUsers />
            </ProtectedAdminRoute>
          }
        />

        <Route
          path="/admin/users/:id"
          element={
            <ProtectedAdminRoute>
              <AdminUserView />
            </ProtectedAdminRoute>
          }
        />

        <Route
          path="/admin/users/:id/edit"
          element={
            <ProtectedAdminRoute>
              <AdminUserForm />
            </ProtectedAdminRoute>
          }
        />

        <Route
          path="/admin/users/new"
          element={
            <ProtectedAdminRoute>
              <AdminUserForm />
            </ProtectedAdminRoute>
          }
        />

        <Route
          path="/superdashboard"
          element={
            <ProtectedSuperRoute>
              <SuperDashboard />
            </ProtectedSuperRoute>
          }
        />

        <Route
          path="/superadmin/profile"
          element={
            <ProtectedSuperRoute>
              <SuperProfile />
            </ProtectedSuperRoute>
          }
        />

        <Route
          path="/superadmin/settings"
          element={
            <ProtectedSuperRoute>
              <SuperSettings />
            </ProtectedSuperRoute>
          }
        />

        <Route
          path="/superadmin/activity-log"
          element={
            <ProtectedSuperRoute>
              <SuperLogin />
            </ProtectedSuperRoute>
          }
        />

        <Route
          path="/superadmin/reports"
          element={
            <ProtectedSuperRoute>
              <SuperReport />
            </ProtectedSuperRoute>
          }
        />

        <Route
          path="/superadmin/support"
          element={
            <ProtectedSuperRoute>
              <SuperTicket />
            </ProtectedSuperRoute>
          }
        />

        <Route
          path="/superadmin/refunds"
          element={
            <ProtectedSuperRoute>
              <SuperAdminRefunds />
            </ProtectedSuperRoute>
          }
        />

        <Route
          path="/superadmin/transactions"
          element={
            <ProtectedSuperRoute>
              <SuperTransaction />
            </ProtectedSuperRoute>
          }
        />

        <Route
          path="/superadmin/invoice"
          element={
            <ProtectedSuperRoute>
              <SuperInvoice />
            </ProtectedSuperRoute>
          }
        />

        <Route
          path="/superadmin/invoice/user/:userId"
          element={
            <ProtectedSuperRoute>
              <SuperUserInvoice />
            </ProtectedSuperRoute>
          }
        />

        <Route
          path="/superadmin/transaction/user/:userId"
          element={
            <ProtectedSuperRoute>
              <SuperUserTransaction />
            </ProtectedSuperRoute>
          }
        />

        <Route
          path="/superadmin/users"
          element={
            <ProtectedSuperRoute>
              <SuperUsers />
            </ProtectedSuperRoute>
          }
        />

        <Route
          path="/superadmin/users/:id"
          element={
            <ProtectedSuperRoute>
              <SuperAdminUserView />
            </ProtectedSuperRoute>
          }
        />

        <Route
          path="/superadmin/users/:id/edit"
          element={
            <ProtectedSuperRoute>
              <SuperAdminUserForm />
            </ProtectedSuperRoute>
          }
        />

        <Route
          path="/superadmin/users/new"
          element={
            <ProtectedSuperRoute>
              <SuperAdminUserForm />
            </ProtectedSuperRoute>
          }
        />

        {/* Catch-all */}
        <Route path="*" element={<NotFound />} />
      </Routes>

      {/* Toast Container */}
      <ToastContainer position="top-right" autoClose={3000} />
    </>
  );
}